import React from 'react'
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { appGlobal } from '../api/appGlobal';
import { mtUpdatePerson } from "../api/mtUpdatePerson";
import { getOcrdataLicConducirAutoTrans } from '../api/getOcrdataLicConducirAutoTrans';
import { getUUID } from "../api/getUUID";
import ValidateContext from '../context/context'
import Steps from "./Steps";
import incode from "./incode";
import "./styles.css";

//renderizamos tutorial del reverso de la Id
function TutorialFrontId({ token, onSuccess }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderFrontTutorial(containerRef.current, {
      onSuccess,
      noWait: true
    });
    isMounted.current = true;
  }, [onSuccess]);

  return <div ref={containerRef}></div>;
}

//renderizamos camara para captura el reverso de la Id
function FrontId({ session, onSuccess, showError }) {

  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("front", containerRef.current, {
      onSuccess,
      onError: showError,
      token: session,
      numberOfTries: -1
    });
    isMounted.current = true;
  }, [onSuccess, showError, session]);

  return <div ref={containerRef}></div>;
}

//renderizamos camara para captura el anverso de la Id
function BackId({ session, onSuccess, showError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("back", containerRef.current, {
      onSuccess,
      onError: showError,
      token: session,
      numberOfTries: -1
    });
    isMounted.current = true;
  }, [onSuccess, showError, session]);

  return <div ref={containerRef}></div>;
}

//procesamos las capturas de la Id
function ProcessId({ session, onSuccess }) {

  incode.addPhone({ token: session.token }).then(res => res)
  incode.addCustomFields({ token: session.token })

  useEffect(() => {
    incode.processId({ token: session.token }).then(() => {
      onSuccess();
    });
  }, [onSuccess, session]);

  return <p>Processing...</p>;
}

//renderizamos la camara para capturar la selfie
function Selfie({ session, onSuccess, showError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("selfie", containerRef.current, {
      onSuccess,
      onError: showError,
      token: session,
      numberOfTries: 3
    });
    isMounted.current = true;
  }, [onSuccess, showError, session]);

  return <div ref={containerRef}></div>;
}

//finalizamos sesion de incode y vamos a la panta lla de verifaIdentificacion... si todo sale bien

function FinishSession({ session, navigate, rutaContinue, typeCredential }) {

  const containerRef = useRef();

  let flowId = appGlobal.configurationId;
  let token = session.token;

  useEffect(() => {

    incode.getFinishStatus(flowId, { token });

    if (typeCredential == "ine") {

      localStorage.setItem("interviewIdINE", session.interviewId);
      localStorage.setItem("tokenIncodeINE", session.token);
      navigate(rutaContinue);

    } else if (typeCredential == "lic") {

      localStorage.setItem("interviewIdLic", session.interviewId);
      localStorage.setItem("tokenIncodeLic", session.token);
      getConfirmar(navigate, rutaContinue);

    }

  })
  return <div ref={containerRef}></div>;
}

async function getConfirmar(navigate, rutaContinue) {

  const objIncodeSimilary = {
    interviewId: localStorage.getItem("interviewIdLic"),
    tokenIncode: localStorage.getItem("tokenIncodeLic"),
    licenseNumber: localStorage.getItem("numeroLicencia"),
    nombre: localStorage.getItem("nombre"),
    paterno: localStorage.getItem("paterno"),
    materno: localStorage.getItem("materno"),
  }

  const responseSimilary = await getOcrdataLicConducirAutoTrans(objIncodeSimilary);

  if (responseSimilary.status === 200) {

    const objModelIncode = {
      interviewId: localStorage.getItem("interviewIdLic"),
      tokenIncode: localStorage.getItem("tokenIncodeLic"),
    };

    const responseModel = await getUUID(objModelIncode);

    if (responseModel.status === 200) {

      const objPerson = {
        id: localStorage.getItem('idPerson'),
        interviewIdLic: localStorage.getItem("interviewIdLic"),
        tokenIncodeLic: localStorage.getItem("tokenIncodeLic"),
        edoEmisor: localStorage.getItem("emisor"),
        edoEmisorISO: localStorage.getItem("emisorISO"),
        tipoLic: localStorage.getItem("tipoLicencia"),
        numeroLic: localStorage.getItem("numeroLicencia"),
        vigencia: localStorage.getItem("vigencia"),
        datosLicenciaCompleto: true,
        similarity: responseSimilary.similarity,
        uuidLic: responseModel.uuid,
        vigenciaLicIncode:responseSimilary.expireAtStr,
      }

      const response = await mtUpdatePerson(objPerson);

      if (response.status === 200) {

        localStorage.removeItem("emisor");
        localStorage.removeItem("emisorISO");
        localStorage.removeItem("tipoLicencia");
        localStorage.removeItem("numeroLicencia");
        navigate(rutaContinue);

      } else {
        localStorage.setItem("erroLicenciaMsj", response.message);
        navigate("/ValidacionLicencia");
      }

    } else {

      localStorage.setItem("erroLicenciaMsj", responseModel.message);
      navigate("/ValidacionLicencia");

    }

  } else {
    localStorage.setItem("erroLicenciaMsj", responseSimilary.message);
    navigate("/ValidacionLicencia");
  }

}

export default function AppIncodeLicencia() {

  const location = useLocation();
  const rutaContinue = location.state.rutaContinue;
  const typeCredential = location.state.typeCredential;

  //iniciar estados
  const [session, setSession] = useState();
  const [step, setStep] = useState(1);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  //consumimos el contexto
  const { flujoActual, setFlujoActual } = useContext(ValidateContext);

  //creamos una sesion de incode con un flujo de cliente
  useEffect(() => {
    let flowId = appGlobal.configurationId;
    incode.createSession("ALL", undefined, {
      configurationId: flowId,
    }).then(async (session) => {
      localStorage.setItem("interviewID", session.interviewId)
      setSession(session);
    });
  }, []);

  function goNext() {
    setStep(step + 1);
  }

  function showError() {
    setError(true);
  }

  window.addEventListener('popstate', function (e) {
    var state = e.state;
    if (state !== null) {
      //load content with ajax
      stopCamera();
      console.log("camara detenida =>");
    }
    else {
      console.log(state);
    }
  });

  function stopCamera() {
    //history.go();
  }

  function showExitos() {

    let flowId = appGlobal.configurationId;
    let toke = session.token;

    incode.getFinishStatus(flowId, { toke });

    navigate('/PantallaBase');

  }

  if (!session) return "loading";

  if (error) return "Error!";

  //componentes de incode, se les pasa la session como props
  return (
    <>
      <link
        rel="stylesheet"
        href="https://sdk-js.s3.amazonaws.com/sdk/styles-1.6.4.css"
      />
      <Steps currentStep={step}>
        <TutorialFrontId onSuccess={goNext} />
        <FrontId session={session} onSuccess={goNext} showError={showError} />
        <BackId session={session} onSuccess={goNext} showError={showError} />
        <ProcessId session={session} onSuccess={goNext} showError={showError} />
        <Selfie session={session} onSuccess={goNext} showError={showError} />
        <FinishSession session={session} navigate={navigate} rutaContinue={rutaContinue} typeCredential={typeCredential} />
      </Steps>
    </>
  );
}
